import router from '../router'
import axios from 'axios'
import moment from 'moment'

const types = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT'
}

const state = {
  user: null,
  endpoint: '/users/',
  logged: !!localStorage.token
}

const mutations = {
  setUser (state, user) {
    state.user = user
  },

  [types.LOGIN] (state, data) {
    state.logged = true
    localStorage.token = data.content.token
    localStorage.userId = data.content.user_id
    localStorage.pseudo = data.content.pseudo
    localStorage.expiresAt = moment().add(data.content.expires_in, 'seconds').format()
    axios.defaults.headers.common['X-AUTH-TOKEN'] = localStorage.token
  },

  [types.LOGOUT] (state) {
    state.logged = false
    state.user = null

    localStorage.token = ''
    localStorage.userId = ''
    localStorage.pseudo = ''
    localStorage.expiresAt = ''
    localStorage.token = ''

    delete axios.defaults.headers.common.Authorization
  }
}

const getters = {
  isLogged: state => state.logged
}

const actions = {
  fetchUser ({ commit }) {
    return axios.get('/login/me')
      .then(({ data }) => {
        commit('setUser', data.data)
        return data.data
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },

  login ({ commit, dispatch }, data) {
    commit(types.LOGIN, data)

    // @TODO : informations et statistiques sur l'utilisateur connecté : nombre de sections et notes, notes partagés, pseudo affiché, ...
    // dispatch('fetchUser')

    router.push({ name: 'Sections', params: { status: 'active' } })
  },

  logout ({ commit }) {
    commit(types.LOGOUT)
    router.push({ name: 'Home' })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
